export const formatterMenu = (items,pidTag)=> {
	//console.log(pidTag)
	//pidTag=pidTag.toString()
    let result = [];   
    const itemMap = {};  
    for (const item of items) {
        const id = item.id;
        const pid = item.pid;

        if (!itemMap[id]) {
            itemMap[id] = {
                children: [],
            }
        }
		item.id = item.id;
		item.pid = item.pid;
        itemMap[id] = {
            ...item,
            children: itemMap[id]['children']
        }

        const treeItem = itemMap[id];

        if (pid === pidTag) {
            result.push(treeItem);
        } else {
            if (!itemMap[pid]) {
                itemMap[pid] = {
                children: [],
                }
            }
            itemMap[pid].children.push(treeItem)
        }

    }
	//console.log(result)
    return result;
}